import { setValidationClasses, getInputsByType, getInputFieldsByType } from '../checkout-functions/sef-checkout-functions';
import { onInputPostcode } from '../checkout-functions/sef-checkout-functions-postcode';

document.addEventListener("DOMContentLoaded", () => {
    const billingInputs = getInputsByType('billing');
    const billingFields = getInputFieldsByType('billing');

    const shippingInputs = getInputsByType('shipping');
    const shippingFields = getInputFieldsByType('shipping');

    let billingPostcodeInput = null;
    let billingPostcodeField = null;
    let shippingPostcodeInput = null;
    let shippingPostcodeField = null;

    if (billingInputs) {
        billingPostcodeInput = billingInputs.postcodeInput;
    }

    if (billingFields) {
        billingPostcodeField = billingFields.postcodeField;
    }

    if (shippingInputs) {
        shippingPostcodeInput = shippingInputs.postcodeInput;
    }

    if (shippingFields) {
        shippingPostcodeField = shippingFields.postcodeField;
    }

    if (billingPostcodeInput && billingPostcodeField) {
        billingPostcodeInput.addEventListener('input', () => onInputPostcode('billing'), false);
        billingPostcodeInput.addEventListener('blur', () => { setValidationClasses(billingPostcodeInput, billingPostcodeField); }, false);
    }

    if (shippingPostcodeInput && shippingPostcodeField) {
        shippingPostcodeInput.addEventListener('input', () => onInputPostcode('shipping'), false);
        shippingPostcodeInput.addEventListener('blur', () => { setValidationClasses(shippingPostcodeInput, shippingPostcodeField); }, false);
    }
});
